import { colors } from '@sweep-io/sweep-design';

export const colorPickerLightColors = {
  Blue: colors.blue[100], // #DBEFFF
  Sky100: colors.sky[100], // #E1EBFF
  Lemon: colors.lemon[100], // #FFF4BF
  Mint: colors.mint[100], // #DFF8D5
  Seafoam: colors.seafoam[100], // #DEFBFF
  Sun: colors.sun[100], // #FFF0D9
  Grey150: colors.grey[150], // #F4F6FF
  Lilac: colors.lilac[100], // #EBDEFF
  Gum: colors.gum[100], // #FEDFF9
  Blush: colors.blush[100], // #FFE9E0
  Grey300: colors.grey[300], // #F4F6FF
  White: colors.white, // #FFFFFF
};

export const colorPickerDarkColors = {
  Black: colors.black,
  White: colors.white,
  Grey700: colors.grey[700], // #696D6F
  Grey500: colors.grey[500], // #A0A7AB
  Seafoam300: colors.seafoam[300], // #C6EAEF
  Blush500: colors.blush[500], // #FF572E
  Sun500: colors.sun[500], // #FF9900
  Lemon500: colors.lemon[500], // #FCE624
  Sky500: colors.sky[500], // #577EE4
  Grey300: colors.grey[300], // #DEDFE0
  Blue500: colors.blue[500], // #1198FF
  Gum500: colors.gum[500], // #F371E6
  Mint700: colors.mint[700], // #2EB67D
};

// Backward compatibility
export const colorPickerColors = colorPickerLightColors;

export const getColorPickerColorLabel = (color: string, palette: 'light' | 'dark' = 'light') => {
  const colorMap = palette === 'light' ? colorPickerLightColors : colorPickerDarkColors;
  return Object.keys(colorMap).find((key) => colorMap[key as keyof typeof colorMap] === color);
};
